

const CampaignsPage = () => {
    return (
        <div className="flex items-center justify-center bg-green-100">Campaigns Page</div>
    )
}

export default CampaignsPage